import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import Divider from '@material-ui/core/Divider';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import Autocomplete from '@material-ui/lab/Autocomplete';
import SelecaoPaciente from 'views/WizardDemanda/SelecaoPaciente';
import { FaSpinner, FaWindowClose } from 'react-icons/fa';
import MaskedInput from 'react-text-mask';
import PropTypes from 'prop-types';
import { PendenciasWizard, setPendencia, iniciaPilhaPendencias } from '../../ValidacaoWizard';
import {
  dominioHCFamema,
  dominioDemandaCirurgica,
  dominioOperaAspNet,
} from '../../../../config/database';
import 'assets/css/geral.css';

const TextMaskCelularCustom = props => {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={inputRef}
      mask={[
        '(',
        /[1-9]/,
        /\d/,
        ')',
        ' ',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
      ]}
      placeholderChar={'\u2000'}
      showMask
    />
  );
};

const TextMaskTelefoneCustom = props => {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={inputRef}
      mask={['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
      placeholderChar={'\u2000'}
      showMask
    />
  );
};

TextMaskCelularCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

TextMaskTelefoneCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

class PacienteExistente extends Component {
  state = {
    informacoesPaciente: {},
    listaConvenio: [],
    pacientes: [],
    loading: false,
    erroNomeFiltro: false,
    erroFAAFiltro: false,
    erroNumeroInternacaoFiltro: false,
    erroProntuarioFiltro: false,
    msgErroNomeFiltro: '',
    msgErroFAAFiltro: '',
    msgErroNumeroInternacaoFiltro: '',
    msgErroProntuarioFiltro: '',
    convenio: null,
    peso: null,
    faa: null,
    celular: null,
    telefone: null,
    email: null,
    prontuario: null,
  };

  handleChange = name => e => {
    this.setState({
      [name]: e.target.value.replace(/[^0-9]/g, ''),
    });
    localStorage.setItem(name, e.target.value.replace(/[^0-9]/g, ''));
  };

  componentDidMount() {
    const paciente = localStorage.getItem('paciente');
    const convenio = localStorage.getItem('convenio');
    const peso = localStorage.getItem('peso');
    const faa = localStorage.getItem('faa');
    const telefone = localStorage.getItem('telefone');
    const celular = localStorage.getItem('celular');
    const email = localStorage.getItem('email');
    const configuracoes = JSON.parse(localStorage.getItem('configuracoes'));

    if (paciente) {
      this.setState({
        informacoesPaciente: JSON.parse(paciente),
      });
    }
    if (convenio) {
      this.setState({ convenio: JSON.parse(convenio) });
      setPendencia(0, PendenciasWizard.convenio, 'pendenciasPaciente');
    }
    if (peso) this.setState({ peso });
    if (faa) this.setState({ faa });

    if (telefone) this.setState({ telefone });
    else if (paciente)
      this.setState({
        telefone: JSON.parse(paciente).TELEFONE ? `14${JSON.parse(paciente).TELEFONE}` : '',
      });
    if (celular) {
      this.setState({ celular });
    } else if (paciente) {
      this.setState({
        celular: JSON.parse(paciente).CELULAR ? `14${JSON.parse(paciente).CELULAR}` : '',
      });
    }
    if (email) this.setState({ email });
    else if (paciente) this.setState({ email: JSON.parse(paciente).EMAIL });

    dominioDemandaCirurgica
      .get(`/api/convenioPorCategoria/${configuracoes.categoriaConvenioPublico}`)
      .then(response => {
        this.setState({ listaConvenio: response.data });
      });
  }

  setOpenModal = () => {
    this.setState({ openModal: true });
  };

  setCloseModal = async () => {
    if (localStorage.getItem('paciente')) {
      let { CELULAR, EMAIL, TELEFONE } = JSON.parse(localStorage.getItem('paciente'));

      if (TELEFONE && TELEFONE.length === 9) {
        if (!CELULAR) CELULAR = TELEFONE;
        TELEFONE = null;
      }

      await this.setState({
        informacoesPaciente: JSON.parse(localStorage.getItem('paciente')),
        email: EMAIL,
        celular: CELULAR ? `14${CELULAR}` : null,
        telefone: TELEFONE ? `14${TELEFONE}` : null,
        openModal: false,
      });
    } else this.setState({ openModal: false });
  };

  limparAtendimentoInternacao = () => {
    localStorage.removeItem('atendimento');
    localStorage.removeItem('internacao');
  };

  handlePesquisa = () => {
    this.limparAtendimentoInternacao();
    iniciaPilhaPendencias();
    setPendencia(0, PendenciasWizard.convenio, 'pendenciasPaciente');
    this.setState({ loading: true });

    const nomePaciente = document.getElementById('nomePacienteFiltro').value;
    const faa = document.getElementById('faa').value;
    const prontuario = document.getElementById('prontuario').value;
    const numeroInternacao = document.getElementById('numeroInternacao').value;

    if (!faa && !nomePaciente && !prontuario && !numeroInternacao) {
      this.setState({
        loading: false,
        erroNomeFiltro: true,
        msgErroNomeFiltro: 'Nome de paciente não encontrado',
      });
    }

    if (faa) {
      dominioHCFamema.get(`/api/listarAtendimentoFAA/${faa}`).then(
        response => {
          this.setState({
            informacoesPaciente: response.data,
            celular: response.data.CELULAR ? `14${response.data.CELULAR}` : null,
            loading: false,
            erroFAAFiltro: false,
            msgErroFAAFiltro: '',
          });
          setPendencia(0, PendenciasWizard.atendimentoInternacao, 'pendenciasPaciente');

          const atendimento = {
            DAT_HORA_ATENDIMENTO: response.data.DAT_HORA_ATENDIMENTO,
            NOM_CARATER_ATENDIMENTO: response.data.NOM_CARATER_ATENDIMENTO,
            NOM_CENTRO_CUSTO: response.data.NOM_CENTRO_CUSTO,
            NRO_FAA: response.data.NRO_FAA,
            SEQ_ATENDIMENTO: response.data.SEQ_ATENDIMENTO,
            SEQ_CARATER_ATENDIMENTO: response.data.SEQ_CARATER_ATENDIMENTO,
            SEQ_CENTRO_CUSTO: response.data.SEQ_CENTRO_CUSTO,
          };

          localStorage.setItem('atendimento', JSON.stringify(atendimento));

          localStorage.removeItem('exames');
          if (response.data.SEQ_INTERNACAO)
            dominioOperaAspNet
              .get(`/api/listaexamesselecaointernacaoopera/${response.data.SEQ_INTERNACAO}`)
              .then(
                async resExamesSihosp => {
                  let exames = [];
                  await dominioDemandaCirurgica.get('/api/itemExame').then(resExames => {
                    exames = resExames.data
                      .filter(exame =>
                        resExamesSihosp.data.some(
                          examesSihosp => exame.idLegado === examesSihosp.SEQ_EXAME
                        )
                      )
                      .sort((exameA, exameB) => {
                        if (exameA.descricao < exameB.descricao) {
                          return -1;
                        }
                        if (exameA.descricao > exameB.descricao) {
                          return 1;
                        }
                        return 0;
                      });
                  });
                  localStorage.setItem('examesAtendimento', JSON.stringify(exames));
                },
                () => {}
              );
          else if (response.data.SEQ_ATENDIMENTO)
            dominioHCFamema
              .get(`/api/listaexamesselecaoatendimentopera/${response.data.SEQ_ATENDIMENTO}`)
              .then(
                async resExamesSihosp => {
                  let exames = [];
                  await dominioDemandaCirurgica.get('/api/itemExame').then(resExames => {
                    exames = resExames.data
                      .filter(exame =>
                        resExamesSihosp.data.some(
                          examesSihosp => exame.idLegado === examesSihosp.SEQ_EXAME
                        )
                      )
                      .sort((exameA, exameB) => {
                        if (exameA.descricao < exameB.descricao) {
                          return -1;
                        }
                        if (exameA.descricao > exameB.descricao) {
                          return 1;
                        }
                        return 0;
                      });
                  });
                  localStorage.setItem('examesAtendimento', JSON.stringify(exames));
                },
                () => {}
              );

          this.setPaciente(response.data);
        },
        () => {
          this.setState({
            loading: false,
            erroFAAFiltro: true,
            msgErroFAAFiltro: 'Número de ficha não econtrado',
          });
        }
      );
    } else if (numeroInternacao) {
      dominioOperaAspNet.get(`/api/listarInternacaoNumero/${numeroInternacao}`).then(
        response => {
          if (response.data.length === 0) {
            this.setState({
              loading: false,
              erroNumeroInternacaoFiltro: true,
              msgErroNumeroInternacaoFiltro: 'Número de internação não econtrado',
            });
          } else {
            this.setState({
              informacoesPaciente: response.data,
              celular: response.data.CELULAR ? `14${response.data.CELULAR}` : null,
              loading: false,
              erroNumeroInternacaoFiltro: false,
              msgErroNumeroInternacaoFiltro: '',
            });
            setPendencia(0, PendenciasWizard.atendimentoInternacao, 'pendenciasPaciente');

            localStorage.removeItem('exames');
            if (response.data.SEQ_INTERNACAO)
              dominioOperaAspNet
                .get(`/api/listaexamesselecaointernacaoopera/${response.data.SEQ_INTERNACAO}`)
                .then(
                  async resExamesSihosp => {
                    let exames = [];
                    await dominioDemandaCirurgica.get('/api/itemExame').then(resExames => {
                      exames = resExames.data
                        .filter(exame =>
                          resExamesSihosp.data.some(
                            examesSihosp => exame.idLegado === examesSihosp.SEQ_EXAME
                          )
                        )
                        .sort((exameA, exameB) => {
                          if (exameA.descricao < exameB.descricao) {
                            return -1;
                          }
                          if (exameA.descricao > exameB.descricao) {
                            return 1;
                          }
                          return 0;
                        });
                    });
                    localStorage.setItem('examesAtendimento', JSON.stringify(exames));
                  },
                  () => {}
                );
            else if (response.data.SEQ_ATENDIMENTO)
              dominioHCFamema
                .get(`/api/listaexamesselecaoatendimentopera/${response.data.SEQ_ATENDIMENTO}`)
                .then(
                  async resExamesSihosp => {
                    let exames = [];
                    await dominioDemandaCirurgica.get('/api/itemExame').then(resExames => {
                      exames = resExames.data
                        .filter(exame =>
                          resExamesSihosp.data.some(
                            examesSihosp => exame.idLegado === examesSihosp.SEQ_EXAME
                          )
                        )
                        .sort((exameA, exameB) => {
                          if (exameA.descricao < exameB.descricao) {
                            return -1;
                          }
                          if (exameA.descricao > exameB.descricao) {
                            return 1;
                          }
                          return 0;
                        });
                    });
                    localStorage.setItem('examesAtendimento', JSON.stringify(exames));
                  },
                  () => {}
                );

            this.setPaciente(response.data);
            localStorage.removeItem('atendimento');
          }
        },
        () => {
          this.setState({
            loading: false,
            erroNumeroInternacaoFiltro: true,
            msgErroNumeroInternacaoFiltro: 'Número de internação não econtrado',
          });
        }
      );
    } else if (nomePaciente) {
      dominioHCFamema.get(`/api/listarPacientesNome/${nomePaciente}`).then(
        response => {
          this.setState({
            pacientes: response.data,
            loading: false,
            erroNomeFiltro: false,
            msgErroNomeFiltro: '',
          });
          this.setOpenModal();
        },
        () => {
          this.setState({
            loading: false,
            erroNomeFiltro: true,
            msgErroNomeFiltro: 'Nome de paciente não encontrado',
          });
        }
      );
    } else if (prontuario) {
      dominioHCFamema.get(`/api/listarPacientesProntuario/${prontuario}`).then(
        response => {
          this.setState({
            pacientes: response.data,
            loading: false,
            erroProntuarioFiltro: false,
            msgErroProntuarioFiltro: '',
          });
          this.setOpenModal();
        },
        () => {
          this.setState({
            loading: false,
            erroProntuarioFiltro: true,
            msgErroProntuarioFiltro: 'Registro não encontrado',
          });
        }
      );
    }
  };

  getSexo = () => {
    if (this.state.informacoesPaciente.COD_SEXO) {
      return this.state.informacoesPaciente.COD_SEXO === 'M' ? 'Masculino' : 'Feminino';
    }

    return null;
  };

  getDataNascimentoFormatada = () => {
    if (this.state.informacoesPaciente.DAT_NASCIMENTO) {
      const data = new Date(this.state.informacoesPaciente.DAT_NASCIMENTO);
      data.setDate(data.getDate() + 1);
      return data.toLocaleDateString('pt-BR');
    }

    return null;
  };

  setPaciente = paciente => {
    localStorage.setItem('paciente', JSON.stringify(paciente));
  };

  render() {
    return (
      <Container>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={this.state.openModal}
          onClose={this.setCloseModal}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
          style={{ width: '60vw' }}
        >
          <Fade in={this.state.openModal}>
            <div className="modal-paciente">
              <button
                type="button"
                onClick={this.setCloseModal}
                style={{ float: 'right', cursor: 'pointer', background: 'none', border: 'none' }}
              >
                <FaWindowClose color="black" size={18} />
              </button>
              <SelecaoPaciente pacientes={this.state.pacientes} closeModal={this.setCloseModal} />
            </div>
          </Fade>
        </Modal>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12}>
            <h3>Filtros</h3>
          </Grid>
          <Grid item xs={12} sm={12}>
            <TextField
              error={this.state.erroProntuarioFiltro}
              helperText={this.state.msgErroProntuarioFiltro}
              autoComplete="off"
              name="prontuario"
              variant="outlined"
              type="number"
              fullWidth
              id="prontuario"
              label="Registro do paciente / Prontuário"
              value={this.state.prontuario}
              onChange={e => {
                if (e.target.value.toString().includes('-')) {
                  alert('Valor negativo não permitido');
                  e.target.value = '';
                }
                this.setState({
                  erroProntuarioFiltro: false,
                  msgErroProntuarioFiltro: '',
                });
              }}
              onKeyDown={e => {
                if (e.key === 'Enter') {
                  this.handlePesquisa();
                }
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              error={this.state.erroFAAFiltro}
              helperText={this.state.msgErroFAAFiltro}
              autoComplete="off"
              name="faa"
              variant="outlined"
              type="number"
              fullWidth
              id="faa"
              label="FAA / Ficha PS"
              value={this.state.faa}
              onChange={e => {
                if (e.target.value.toString().includes('-')) {
                  alert('Valor negativo não permitido');
                  e.target.value = '';
                }
                this.setState({
                  erroFAAFiltro: false,
                  msgErroFAAFiltro: '',
                });
                localStorage.setItem('faa', e.target.value);
                this.setState({ faa: e.target.value });
              }}
              onKeyDown={e => {
                if (e.key === 'Enter') {
                  this.handlePesquisa();
                }
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              error={this.state.erroNumeroInternacaoFiltro}
              helperText={this.state.msgErroNumeroInternacaoFiltro}
              autoComplete="off"
              name="numeroInternacao"
              fullWidth
              variant="outlined"
              type="number"
              id="numeroInternacao"
              label="Ficha de Internação"
              value={this.state.numeroInternacao}
              onChange={e => {
                if (e.target.value.toString().includes('-')) {
                  alert('Valor negativo não permitido');
                  e.target.value = '';
                }
                this.setState({
                  erroNumeroInternacaoFiltro: false,
                  msgErroNumeroInternacaoFiltro: '',
                });
                localStorage.setItem('numeroInternacao', e.target.value);
                this.setState({ numeroInternacao: e.target.value });
              }}
              onKeyDown={e => {
                if (e.key === 'Enter') {
                  this.handlePesquisa();
                }
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <TextField
              error={this.state.erroNomeFiltro}
              helperText={this.state.msgErroNomeFiltro}
              autoComplete="off"
              name="nomePacienteFiltro"
              variant="outlined"
              fullWidth
              id="nomePacienteFiltro"
              label="Nome do paciente"
              value={this.state.nomePacienteFiltro}
              onChange={e => {
                this.setState({ nomePacienteFiltro: e.target.value });
                this.setState({
                  erroNomeFiltro: false,
                  msgErroNomeFiltro: '',
                });
              }}
              inputProps={{
                minLength: 10,
                style: { textTransform: 'uppercase' },
              }}
              onKeyDown={e => {
                if (e.key === 'Enter') {
                  this.handlePesquisa();
                }
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <Button
              variant="contained"
              color="primary"
              style={{ margin: 'auto auto', top: '10px', float: 'right' }}
              onClick={this.handlePesquisa}
            >
              {this.state.loading ? (
                <FaSpinner color="#FFF" className="loading" size={14} />
              ) : (
                <> Pesquisar </>
              )}
            </Button>
          </Grid>
        </Grid>
        <br />
        <Divider />
        <br />
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12}>
            <h3>Dados do paciente</h3>
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              autoComplete="off"
              name="prontuario"
              variant="outlined"
              fullWidth
              id="prontuario"
              label="Prontuário"
              InputProps={{
                readOnly: true,
              }}
              InputLabelProps={{ shrink: true }}
              value={this.state.informacoesPaciente.NRO_PRONTUARIO}
            />
          </Grid>
          <Grid item xs={12} sm={9}>
            <TextField
              autoComplete="off"
              name="nome"
              variant="outlined"
              fullWidth
              id="nome"
              label="Nome"
              InputProps={{
                readOnly: true,
              }}
              InputLabelProps={{ shrink: true }}
              value={this.state.informacoesPaciente.NOM_PESSOA}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              autoComplete="off"
              name="nascimento"
              variant="outlined"
              fullWidth
              id="nascimento"
              label="Nascimento"
              InputProps={{
                readOnly: true,
              }}
              InputLabelProps={{ shrink: true }}
              value={this.getDataNascimentoFormatada()}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              autoComplete="off"
              name="sexo"
              variant="outlined"
              fullWidth
              id="sexo"
              label="Sexo"
              InputProps={{
                readOnly: true,
              }}
              InputLabelProps={{ shrink: true }}
              value={this.getSexo()}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id="telefone"
              label="Telefone"
              variant="outlined"
              fullWidth
              InputLabelProps={{ shrink: true }}
              value={this.state.telefone}
              InputProps={{
                inputComponent: TextMaskTelefoneCustom,
                onChange: this.handleChange('telefone'),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id="celular"
              label="Celular"
              variant="outlined"
              fullWidth
              InputLabelProps={{ shrink: true }}
              value={this.state.celular}
              InputProps={{
                inputComponent: TextMaskCelularCustom,
              }}
              onChange={e => {
                localStorage.setItem('celular', e.target.value.replace(/[^0-9]/g, ''));
                this.setState({ celular: e.target.value.replace(/[^0-9]/g, '') });
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <TextField
              autoComplete="off"
              name="email"
              type="email"
              variant="outlined"
              fullWidth
              id="email"
              label="E-mail"
              InputLabelProps={{ shrink: true }}
              value={this.state.email}
              onChange={e => {
                localStorage.setItem('email', e.target.value);
                this.setState({ email: e.target.value });
              }}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              autoComplete="off"
              name="peso"
              type="number"
              variant="outlined"
              fullWidth
              id="peso"
              label="Peso"
              value={this.state.peso}
              maxLength="4"
              onChange={e => {
                if (e.target.value.length > 6) {
                  e.target.value = e.target.value.substring(0, 6);
                }
                localStorage.setItem('peso', e.target.value);
                this.setState({ peso: e.target.value });
                setPendencia(0, PendenciasWizard.peso, 'pendenciasPaciente');
              }}
              InputProps={{
                inputProps: {
                  max: 100,
                  min: 0,
                  maxLength: 4,
                },
                maxLength: 4,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={9}>
            <Autocomplete
              id="convenio"
              options={this.state.listaConvenio}
              getOptionLabel={option => `${option.descricao}`}
              fullWidth
              value={this.state.convenio}
              onChange={(e, values) => {
                localStorage.setItem('convenio', JSON.stringify(values));
                this.setState({ convenio: values });
                setPendencia(0, PendenciasWizard.convenio, 'pendenciasPaciente');
              }}
              renderInput={params => <TextField {...params} label="Convênio" variant="outlined" />}
            />
          </Grid>
        </Grid>
      </Container>
    );
  }
}

export default PacienteExistente;
